module.exports = __webpack_public_path__ + "img/carrier-logo.25c5bf28.png";